import script from "./BaseAudioElement.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseAudioElement.vue?vue&type=script&lang=ts&setup=true"

import "./BaseAudioElement.vue?vue&type=style&index=0&id=5258e03b&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5258e03b"]])

export default __exports__